import FormSection from './FormSection'
import { translations } from '../../data/translations'
import './FormSection.css'

const FeaturesSection = ({ formData, updateFormData, language }) => {
  const t = translations[language]?.features || translations.de.features

  const handleCheckboxChange = (field, value, checked) => {
    const current = formData[field] || []
    const updated = checked
      ? [...current, value]
      : current.filter(v => v !== value)
    updateFormData(field, updated)
  }

  return (
    <FormSection title={t.title} subtitle={t.subtitle}>
      <h3 className="form-section__subtitle">{t.subtitle1}</h3>
      
      <div className="form-group">
        <label className="form-group__label">{t.featuresLabel}</label>
        <div className="checkbox-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '8px' }}>
          {t.featuresOptions.map((option) => (
            <label key={option.value} className="radio-group__option" style={{ padding: '8px 12px' }}>
              <input
                type="checkbox"
                name="features[]"
                value={option.value}
                checked={(formData.features || []).includes(option.value)}
                onChange={(e) => handleCheckboxChange('features', option.value, e.target.checked)}
              />
              <span className="radio-group__label" style={{ fontSize: '0.9rem' }}>{option.label}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="features_weitere" className="form-group__label">
          {t.features_weitere}
        </label>
        <input
          type="text"
          id="features_weitere"
          name="features_weitere"
          className="form-group__input"
          placeholder={t.features_weiterePlaceholder}
          value={formData.features_weitere || ''}
          onChange={(e) => updateFormData('features_weitere', e.target.value)}
        />
      </div>

      <h3 className="form-section__subtitle">{t.subtitle2}</h3>

      <div className="form-group">
        <label className="form-group__label">{t.formulareLabel}</label>
        <div className="checkbox-group">
          {t.formulareOptions.map((option) => (
            <label key={option.value} className="radio-group__option">
              <input
                type="checkbox"
                name="formulare[]"
                value={option.value}
                checked={(formData.formulare || []).includes(option.value)}
                onChange={(e) => handleCheckboxChange('formulare', option.value, e.target.checked)}
              />
              <span className="radio-group__label">{option.label}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="formulare_weitere" className="form-group__label">
          {t.formulare_weitere}
        </label>
        <input
          type="text"
          id="formulare_weitere"
          name="formulare_weitere"
          className="form-group__input"
          placeholder={t.formulare_weiterePlaceholder}
          value={formData.formulare_weitere || ''}
          onChange={(e) => updateFormData('formulare_weitere', e.target.value)}
        />
      </div>
    </FormSection>
  )
}

export default FeaturesSection
